export const formatDate = (dateISO, formato = "dd/mm/yyyy") => {
    const fecha = new Date(dateISO);
    const mapa = {
        dd: String(fecha.getDate()).padStart(2, "0"),
        mm: String(fecha.getMonth() + 1).padStart(2, "0"),
        yyyy: fecha.getFullYear(),
        yy: String(fecha.getFullYear()).slice(-2),
        hh: String(fecha.getHours() % 12 || 12).padStart(2, "0"),
        HH: String(fecha.getHours()).padStart(2, "0"),
        MM: String(fecha.getMinutes()).padStart(2, "0"),
        ss: String(fecha.getSeconds()).padStart(2, "0"),
        ampm: fecha.getHours() >= 12 ? "PM" : "AM",
        mmmm: [
            "enero",
            "febrero",
            "marzo",
            "abril",
            "mayo",
            "junio",
            "julio",
            "agosto",
            "septiembre",
            "octubre",
            "noviembre",
            "diciembre",
        ][fecha.getMonth()],
        dddd: [
            "domingo",
            "lunes",
            "martes",
            "miércoles",
            "jueves",
            "viernes",
            "sábado",
        ][fecha.getDay()],
    };

    return formato.replace(
        /dd|mm|yyyy|yy|hh|HH|MM|ss|ampm|mmmm|dddd/g,
        (matched) => mapa[matched]
    );
};
